<template>
    <section id="result">
        <router-link class="btnHome" :to="{ name: 'Home' }"></router-link>
        <div id="container">
            <h1>#null<span class="yellow">.</span></h1>
            <h2>He who wanders is not always 404.</h2>
        </div>
    </section>
</template>

<script>
  export default {
    name: "EpicFail"
  }
</script>

<style lang="scss" scoped>
    #result {
        #container {
            //width: 80vw;
            margin-left: 12vw;
            margin-top: 10vw;
            h1 {
                font-size: 8vw;
                margin-bottom: 2vw;

                .yellow {
                    color: $yellow;
                }
            }
            h2 {
                font-size: 4vw;
                color: $grey;
            }
        }
        
    }
    @media screen and (max-width: $breakpoint-xl) {
        #result {
            #container {
                margin-left: 15vw;
                margin-top: 12vw;
            }
        }
    }
    @media screen and (max-width: $breakpoint-md) {
        #result {
            #container {
                margin-left: 20vw;
                margin-top: 15vw;

                h1 {
                    font-size: 12vw;
                }
                h2 {
                    font-size: 6vw;
                    line-height: 8vw;
                }
            }
        }
    }
</style>